"use strict";

Shopify.theme.jsFeaturedCollection = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

    if (this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      Shopify.theme.applyMasonry();
    }

    if (this.collection_style == 'slider') {
      this.createSlider();
    }
  },
  createSlider: function createSlider() {
    var featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery').removeClass('is-hidden');

    let $slider = {}
    var slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "center",
      wrapAround: true,
      groupCells: 4,
      imagesLoaded:true
    };
    if ( matchMedia('screen and (max-width: 798px)').matches ) {
      slideData.groupCells = 0
    }
    $slider = $(featuredCollectionSlider).flickity({
      freeScroll: true,
      //imagesLoaded: true,
      draggable: true,
//       autoPlay: 5000, 
      cellAlign: 'center',
      pauseAutoPlayOnHover: false,
      wrapAround: slideData.wrapAround,
      pageDots: false,
      contain: true,
      imagesLoaded:true,
      prevNextButtons:  false,
      groupCells:slideData.groupCells,
      arrowShape: arrowShape,
      on: {
        ready: function ready() {
          // Reset layout to avoid collapsing issues
          setTimeout(function () {
            $(featuredCollectionSlider).flickity('resize');
          }, 500);
        }
      }
    });
    
    $slider.on('dragMove.flickity', function( event, pointer ) {
      let $cursor = $('.cursor');
      if(!$cursor.length){
      	$slider.off('dragMove.flickity')
        return
      }
      $cursor.css({
          top: event.clientY - $cursor.height() / 2,
          left: event.clientX - $cursor.width() / 2
      });
    });

  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
};